import { render, staticRenderFns } from "./WaterData.vue?vue&type=template&id=fa1b358a&scoped=true"
import script from "./WaterData.vue?vue&type=script&lang=js"
export * from "./WaterData.vue?vue&type=script&lang=js"
import style0 from "./WaterData.vue?vue&type=style&index=0&id=fa1b358a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1b358a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa1b358a')) {
      api.createRecord('fa1b358a', component.options)
    } else {
      api.reload('fa1b358a', component.options)
    }
    module.hot.accept("./WaterData.vue?vue&type=template&id=fa1b358a&scoped=true", function () {
      api.rerender('fa1b358a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyData/WaterData/WaterData.vue"
export default component.exports